import { ApolloError } from "apollo-client";
import React, { ComponentClass, PureComponent, ReactNode } from "react";
import { Query } from "react-apollo";

import { IUser } from "../../../types/user";

import GetMe from "./graphql/GetMe";

export interface IWithMe {
  me: IUser | null;
  meLoading: boolean;
}

export default <P extends object>(
  Component: React.ComponentType<P>
): ComponentClass<P> =>
  class WithMe extends PureComponent<P> {
    public render(): ReactNode {
      return (
        <Query query={GetMe} fetchPolicy="cache-first" errorPolicy="all">
          {({
            loading,
            error,
            data,
          }: {
            data: { me: IUser } | undefined;
            error?: ApolloError;
            loading: boolean;
          }): JSX.Element => {
            const userNotLogged = (error || { graphQLErrors: [] }).graphQLErrors
              // tslint:disable-next-line: no-any
              .some((e: any) => e.code === 401 && e.subError.code === 50);

            if (error && !userNotLogged) {
              // tslint:disable-next-line: no-console
              console.error(error);
            }

            return (
              <Component
                {...this.props}
                me={error || !data || loading ? null : data.me}
                meLoading={loading}
              />
            );
          }}
        </Query>
      );
    }
  };
